import type { OpenAPI } from "simplydo/interfaces";

type LatestLongRunningTask =
  OpenAPI.GET<"/users/{id}/longRunningTask/{for_type}/{for_id}/{task_type}/latest">["response"]["task"];

/** The status of a long-running task notification; other notification types have none. */
export const longRunningTaskStatus = (
  task: LatestLongRunningTask | undefined,
) => (task && "status" in task ? task.status : undefined);
